// GridImage types:
// 'centered'  1 image (landscape or portrait)
//   +---+
//   +---+
//
// 'descending'  2 images (portrait)
//   +-+
//   | | +-+
//   +-+ | |
//       +-+
//
// 'ascending'  2 images (portrait)
//       +-+
//   +-+ | |
//   | | +-+
//   +-+
//
// 'alternating' 2 images (portrait + landscape)
//   +-+
//   | | +--+
//   | | +--+
//   +-+

export const getOrientation = (picture) => {
  return picture.aspect < 1 ? 'portrait' : 'landscape';
};

export const getOrientations = (pictures) => {
  return pictures.map((picture) => (picture.aspect < 1 ? 'portrait' : 'landscape'));
};

export const getOrientationString = (pictures) => {
  return getOrientations(pictures).join(',');
};
